<template>
  <div class="water-status">
    <custom-plane>
      <div class="status-content">
        <div class="status-item">
          <div class="left-text">液位</div>
          <div
            class="right-text"
            :class="levelData[2] == '0' ? 'normalData-color' : 'error-color'"
          >
            {{ levelData[0] }} <span class="unit-text">{{ levelData[1] }}</span>
          </div>
        </div>
        <div class="status-item">
          <div class="left-text">流量</div>
          <div
            class="right-text"
            :class="
              volumeFlowData[2] == '0' ? 'normalData-color' : 'error-color'
            "
          >
            {{ volumeFlowData[0] }}
            <span class="unit-text">{{ volumeFlowData[1] }}</span>
          </div>
        </div>
        <div class="status-item">
          <div class="left-text">进水压力</div>
          <div
            class="right-text"
            :class="
              inletPressureData[2] == '0' ? 'normalData-color' : 'error-color'
            "
          >
            {{ inletPressureData[0] }}
            <span class="unit-text">{{ inletPressureData[1] }}</span>
          </div>
        </div>
        <div class="status-item">
          <div class="left-text">出水压力</div>
          <div
            class="right-text"
            :class="
              outletPressureData[2] == 0 ? 'normalData-color' : 'error-color'
            "
          >
            {{ outletPressureData[0] }}
            <span class="unit-text"> {{ outletPressureData[1] }}</span>
          </div>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  props: {
    waterSupplyData: Object,
  },
  computed: {
    levelData() {
      if (this.waterSupplyData?.level) {
        return [
          this.splitUnit(this.waterSupplyData.level.value),
          "m",
          this.waterSupplyData.level.alarm,
        ];
      }
      return ["-", "", "0"];
    },
    volumeFlowData() {
      if (this.waterSupplyData?.volumeFlow) {
        return [
          this.splitUnit(this.waterSupplyData.volumeFlow.value),
          "m³/h",
          this.waterSupplyData.volumeFlow.alarm,
        ];
      }
      return ["-", "", "0"];
    },
    inletPressureData() {
      if (this.waterSupplyData?.inletPressure) {
        return [
          this.splitUnit(this.waterSupplyData.inletPressure.value),
          "bar",
          this.waterSupplyData.inletPressure.alarm,
        ];
      }
      return ["-", "", "0"];
    },
    outletPressureData() {
      if (this.waterSupplyData?.outletPressure) {
        return [
          this.splitUnit(this.waterSupplyData.outletPressure.value),
          "bar",
          this.waterSupplyData.outletPressure.alarm,
        ];
      }
      return ["-", "", "0"];
    },
  },
  methods: {
    splitUnit(value) {
      let [num] = value.match(/^\d+\.\d+/gi);
      return num;
    },
  },
};
</script>

<style lang="scss" scoped>
.water-status {
  margin-top: 20px;
  width: 100%;
  height: 134px;
  .status-content {
    padding: 20px;
    display: grid;
    grid-template-columns: 148px 148px;
    grid-template-rows: 37px 37px;
    row-gap: 20px;
    column-gap: 80px;
    .status-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left-text {
        width: 56px;
        height: 21px;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        color: #e5e5e5;
        text-align: right;
        flex-shrink: 0;
      }
      .right-text {
        font-family: "dina";
        font-weight: 500;
        font-size: 32px;
        line-height: 37px;
        .unit-text {
          font-family: "dina";
          font-weight: 500;
          font-size: 16px;
          line-height: 18px;
          color: #e5e5e5;
        }
      }
      .normalData-color {
        color: #ffffff;
      }
      .alarm-color {
        color: #f1802f;
      }
    }
  }
}
</style>
